import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {Locale} from 'vant'
import enLocale from 'vant/es/locale/lang/en-US'
import zhLocale from 'vant/es/locale/lang/zh-CN'
import frLocale from 'vant/es/locale/lang/fr-FR'

Vue.use(VueI18n)

const en = require('./en_US.json')
const zh = require('./zh_CN.json')
const fr = require('./fr_FR.json')

const i18n = new VueI18n({
  locale: sessionStorage.getItem('language') || 'fr_FR',
  messages:{
    en_US: {
      ...en,
      ...enLocale
    },
    zh_CN:{
      ...zh,
      ...zhLocale
    },
    fr_FR:{
      ...fr,
      ...frLocale
    }
  }
})

i18n.setLocale = function(locale){
  i18n.locale = locale
  if(locale === 'en_US'){
    Locale.use('en-US', enLocale)
  }else if(locale === 'zh_CN'){
    Locale.use('zh-CN', zhLocale)
  }else if(locale === 'fr_FR'){
    Locale.use('fr-FR', frLocale)
  }
}

i18n.setLocale(i18n.locale)

export default i18n